import { createAsyncThunk } from '@reduxjs/toolkit'
import { ShowException } from 'store/Application/appActions'
import { projectAPIBuilder } from './BoMAsyncActions'
import { RootAppState } from 'store/configureStore'

export const recalculateProjectWithUpdatedPrices = createAsyncThunk<
  void,
  null,
  { state: RootAppState }
>('project/recalculateProjectWithUpdatedPrices', async (_args, thunkAPI) => {
  const { api, projectId } = projectAPIBuilder(thunkAPI.getState)

  try {
    return await api.RecalculateWithUpdatedPrices(projectId)
  } catch (ex) {
    ShowException('project', ex)
    throw ex
  }
})
